module.exports = __webpack_public_path__ + "img/479466451.2c6ae607.jpg";